<template>
  <div
    class="sidebar sidebar-dark sidebar-main sidebar-expand-lg sidebar-main-resized"
  >
    <div class="sidebar-content">
      <div class="sidebar-section">
        <div class="sidebar-section-body d-flex justify-content-center">
          <h5 class="sidebar-resize-hide flex-grow-1 my-auto">Navegação</h5>
          <div>
            <button
              type="button"
              class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-control sidebar-main-resize d-none d-lg-inline-flex"
              title="Expandir/Recolher"
            >
              <i class="ph ph-arrows-left-right"></i>
            </button>
            <button
              type="button"
              class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-mobile-main-toggle d-lg-none"
              title="Fechar"
            >
              <i class="ph ph-x"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="sidebar-section">
        <ul class="nav nav-sidebar" data-nav-type="accordion">
          <li class="nav-item-header pt-0">
            <div
              class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide"
            >
              Main
            </div>
            <i class="ph ph-dots-three sidebar-resize-show"></i>
          </li>
          <li class="nav-item">
            <router-link to="/home" class="nav-link" title="Dashboard">
              <i class="ph ph-house"></i>
              <span>Dashboard</span>
            </router-link>
          </li>
          <template v-if="(isAdmin || isNormal) && user.profiles.length > 0">
            <li class="nav-item-header">
              <div
                class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide"
              >
                Relatórios
              </div>
              <i class="ph ph-dots-three sidebar-resize-show"></i>
            </li>
            <li
              class="nav-item nav-item-submenu"
              v-for="profile in user.profiles"
              :key="profile.perfilId"
            >
              <a href="#" class="nav-link">
                <i class="ph ph-files"></i>
                <span>{{ profile.perfilNome }}</span>
              </a>
              <ul class="nav-group-sub collapse">
                <li
                  class="nav-item"
                  v-for="report in profile.reports"
                  :key="report.id"
                >
                  <router-link :to="`/report/${report.hash}`" class="nav-link">
                    {{ report.nome }}
                  </router-link>
                </li>
              </ul>
            </li>
          </template>
          <template v-if="isAdmin">
            <li class="nav-item-header">
              <div
                class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide"
              >
                Administração
              </div>
              <i class="ph ph-dots-three sidebar-resize-show"></i>
            </li>
            <li class="nav-item">
              <router-link to="/syncdata" class="nav-link" title="Perfis">
                <i class="ph ph-arrows-clockwise"></i>
                <span>Sincronização</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/users" class="nav-link" title="Usuários">
                <i class="ph ph-users"></i>
                <span>Usuários</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/profiles" class="nav-link" title="Perfis">
                <i class="ph ph-faders-horizontal"></i>
                <span>Perfis</span>
              </router-link>
            </li>
          </template>
          <template v-if="isEthos">
            <li class="nav-item-header">
              <div
                class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide"
              >
                Ethos Admin
              </div>
              <i class="ph ph-dots-three sidebar-resize-show"></i>
            </li>
            <li class="nav-item">
              <router-link
                to="/ethos/companies"
                class="nav-link"
                title="Empresas"
              >
                <i class="ph ph-buildings"></i>
                <span>Empresas</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                to="/ethos/reports"
                class="nav-link"
                title="Relatórios"
              >
                <i class="ph ph-files"></i>
                <span>Relatórios</span>
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TipoUsuarioEnum from '@/enums/tipoUsuarioEnum'

export default {
  name: 'Sidebar',

  computed: {
    ...mapGetters(['user']),

    isEthos() {
      return this.user && Number(this.user.tipo) === TipoUsuarioEnum.ETHOS
    },

    isAdmin() {
      return this.user && Number(this.user.tipo) === TipoUsuarioEnum.ADMIN
    },

    isNormal() {
      return this.user && Number(this.user.tipo) === TipoUsuarioEnum.NORMAL
    },
  },

  methods: {
    // Initialize all sidebars
    initSidebars() {
      this.sidebarMainResize()
      this.sidebarMainToggle()
      this.sidebarComponentToggle()
    },

    // Initialize all navigations
    initNavigations() {
      this.navigationSidebar()
    },

    sidebarMainResize() {
      const sidebarMainElement = document.querySelector('.sidebar-main')
      const sidebarMainToggler = document.querySelectorAll(
        '.sidebar-main-resize',
      )
      const resizeClass = 'sidebar-main-resized'
      const unfoldClass = 'sidebar-main-unfold'

      // Config
      if (sidebarMainElement) {
        // Define variables
        const unfoldDelay = 150
        let timerStart
        let timerFinish

        // Toggle classes on click
        sidebarMainToggler.forEach(function (toggler) {
          toggler.addEventListener('click', function (e) {
            e.preventDefault()
            sidebarMainElement.classList.toggle(resizeClass)
            if (!sidebarMainElement.classList.contains(resizeClass)) {
              sidebarMainElement.classList.remove(unfoldClass)
            }
          })
        })

        // Add class on mouse enter
        sidebarMainElement.addEventListener('mouseenter', function () {
          clearTimeout(timerFinish)
          timerStart = setTimeout(function () {
            if (sidebarMainElement.classList.contains(resizeClass)) {
              sidebarMainElement.classList.add(unfoldClass)
            }
          }, unfoldDelay)
        })

        // Remove class on mouse leave
        sidebarMainElement.addEventListener('mouseleave', function () {
          clearTimeout(timerStart)
          timerFinish = setTimeout(function () {
            sidebarMainElement.classList.remove(unfoldClass)
          }, unfoldDelay)
        })
      }
    },

    // Toggle main sidebar
    sidebarMainToggle() {
      // Elements
      const sidebarMainElement = document.querySelector('.sidebar-main')
      const sidebarMainRestElements = document.querySelectorAll(
        '.sidebar:not(.sidebar-main):not(.sidebar-component)',
      )
      const sidebarMainDesktopToggler = document.querySelectorAll(
        '.sidebar-main-toggle',
      )
      const sidebarMainMobileToggler = document.querySelectorAll(
        '.sidebar-mobile-main-toggle',
      )
      const sidebarCollapsedClass = 'sidebar-collapsed'
      const sidebarMobileExpandedClass = 'sidebar-mobile-expanded'

      // On desktop
      sidebarMainDesktopToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
          e.preventDefault()
          sidebarMainElement.classList.toggle(sidebarCollapsedClass)
        })
      })

      // On mobile
      sidebarMainMobileToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
          e.preventDefault()
          sidebarMainElement.classList.toggle(sidebarMobileExpandedClass)

          sidebarMainRestElements.forEach(function (sidebars) {
            sidebars.classList.remove(sidebarMobileExpandedClass)
          })
        })
      })
    },

    // Toggle component sidebar
    sidebarComponentToggle() {
      // Elements
      const sidebarComponentElement =
        document.querySelector('.sidebar-component')
      const sidebarComponentMobileToggler = document.querySelectorAll(
        '.sidebar-mobile-component-toggle',
      )
      const sidebarMobileExpandedClass = 'sidebar-mobile-expanded'

      // Toggle classes
      sidebarComponentMobileToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
          e.preventDefault()
          sidebarComponentElement.classList.toggle(sidebarMobileExpandedClass)
        })
      })
    },

    // Sidebar navigation
    navigationSidebar() {
      // Elements
      const navContainerClass = 'nav-sidebar'
      const navItemOpenClass = 'nav-item-open'
      const navLinkClass = 'nav-link'
      const navLinkDisabledClass = 'disabled'
      const navSubmenuContainerClass = 'nav-item-submenu'
      const navSubmenuClass = 'nav-group-sub'
      const navScrollSpyClass = 'nav-scrollspy'
      const sidebarNavElement = document.querySelectorAll(
        `.${navContainerClass}:not(.${navScrollSpyClass})`,
      )

      // Setup
      sidebarNavElement.forEach(function (nav) {
        nav
          .querySelectorAll(
            `.${navSubmenuContainerClass} > .${navLinkClass}:not(.${navLinkDisabledClass})`,
          )
          .forEach(function (link) {
            link.addEventListener('click', function (e) {
              e.preventDefault()
              const submenuContainer = link.closest(
                `.${navSubmenuContainerClass}`,
              )
              const submenu = link
                .closest(`.${navSubmenuContainerClass}`)
                .querySelector(`:scope > .${navSubmenuClass}`)

              // Collapsible
              if (submenuContainer.classList.contains(navItemOpenClass)) {
                // eslint-disable-next-line no-undef
                new bootstrap.Collapse(submenu).hide()
                submenuContainer.classList.remove(navItemOpenClass)
              } else {
                // eslint-disable-next-line no-undef
                new bootstrap.Collapse(submenu).show()
                submenuContainer.classList.add(navItemOpenClass)
              }

              // Accordion
              if (
                link
                  .closest(`.${navContainerClass}`)
                  .getAttribute('data-nav-type') === 'accordion'
              ) {
                // eslint-disable-next-line no-restricted-syntax
                for (const sibling of link.parentNode.parentNode.children) {
                  if (
                    sibling !== link.parentNode &&
                    sibling.classList.contains(navItemOpenClass)
                  ) {
                    sibling
                      .querySelectorAll(`:scope > .${navSubmenuClass}`)
                      // eslint-disable-next-line no-loop-func, no-shadow
                      .forEach(function (submenu) {
                        // eslint-disable-next-line no-undef
                        new bootstrap.Collapse(submenu).hide()
                        sibling.classList.remove(navItemOpenClass)
                      })
                  }
                }
              }
            })
          })
      })
    },
  },

  mounted() {
    this.initSidebars()
    this.initNavigations()
  },
}
</script>

<style scoped>
.nav-item-submenu > .nav-link:after {
  top: auto;
}

.nav-link.disabled {
  pointer-events: initial;
}
</style>
